<template>
    <div>
      <div v-if="loading && !items" class="uk-flex uk-flex-center spinner-top-padding">
        <spinner></spinner>
      </div>
      <div v-else>
        <div v-if="!items" class="container">
          <span class="uk-flex uk-flex-center heading-style">{{$t('general.nothingToSee')}}</span>
        </div>
        <div v-else>
          <div v-for="item in items" :key="item.contentId">
              <result-item :item="item"></result-item>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import resultItem from '../../search/search-results/desktop/search-result-item'
  import Spinner from '../../ui-components/spinner/spinner'
  import * as misc from '../../../enums/misc'
  import * as _ from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    name: 'pending-resources',
    components: {
      resultItem,
      Spinner
    },
    props: ['loading', 'resources'],
    computed: {
      ...mapGetters(['getPendingQueuePage']),
      items() {
        if (this.resources.length) {
          let start = 0
          let end = misc.PAGING_SIZE
          if (this.getPendingQueuePage > 1) {
            end = misc.PAGING_SIZE * this.getPendingQueuePage
            start = (end - misc.PAGING_SIZE)
          }
          return _.slice(this.resources, start, end)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../src/styles/colours';

  .container {
    margin-top: 100px;
  }

  .heading-style {
    font-size: 30px;
    font-weight: bold;
    color: $content-text;
    margin-top: 23px;
    text-align: center;
  }

  .spinner-top-padding {
    padding-top: 400px;
  }
</style>
